'use client'

import { useId, useState } from 'react'
import { Button } from '@/components/ui/button'
import { ProofCard } from '@/components/site/proof-card'
import type { ProofCardContent } from '@/types/site'

export interface FilterableCaseStudy {
  card: ProofCardContent
  pillar?: string
  industries: string[]
}

/** Case-study listing filtered by pillar (buttons) and industry (select). */
export function CaseStudiesFilter({
  items,
  pillars,
  labels,
}: {
  items: FilterableCaseStudy[]
  pillars: string[]
  labels: { pillar: string; industry: string; all: string; filters: string; empty: string }
}) {
  const id = useId()
  const [pillar, setPillar] = useState('')
  const [industry, setIndustry] = useState('')
  const industries = [...new Set(items.flatMap((item) => item.industries))].sort()
  const visible = items.filter(
    (item) =>
      (!pillar || item.pillar === pillar) && (!industry || item.industries.includes(industry)),
  )
  return (
    <>
      <div className="cs-filters" role="group" aria-label={labels.filters}>
        <div className="cs-filter-pillars" role="group" aria-label={labels.pillar}>
          {['', ...pillars].map((value) => (
            <Button
              key={value || 'all'}
              variant={pillar === value ? 'default' : 'outline'}
              size="sm"
              aria-pressed={pillar === value}
              onClick={() => setPillar(value)}
            >
              {value || labels.all}
            </Button>
          ))}
        </div>
        {industries.length ? (
          <label className="cs-filter-industry" htmlFor={`${id}-industry`}>
            <span>{labels.industry}</span>
            <select
              id={`${id}-industry`}
              value={industry}
              onChange={(event) => setIndustry(event.target.value)}
            >
              <option value="">{labels.all}</option>
              {industries.map((name) => (
                <option key={name}>{name}</option>
              ))}
            </select>
          </label>
        ) : null}
      </div>
      {visible.length ? (
        <div className="home-cs-grid">
          {visible.map((item) => (
            <ProofCard key={item.card.href ?? item.card.company} card={item.card} />
          ))}
        </div>
      ) : (
        <p className="site-section-note" role="status">
          {labels.empty}
        </p>
      )}
    </>
  )
}
